import {inject, injectable} from "inversify";
import {Notification} from "@/modules/notifications/entity";
import {EventEmitter} from "@/modules/base/events";
import {BeforeNotifyEvent} from "@/modules/notifications/events/BeforeNotifyEvent";
import {AfterNotifyEvent} from "@/modules/notifications/events/AfterNotifyEvent";
import {Season} from "@/modules/season/entity";

@injectable()
export class Notifier {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {}

  public async notify(notification: Notification) {
    await this.em.emitAsync(new BeforeNotifyEvent());

    notification.createdAt = (await Season.current()).currentDateRaw;
    await notification.save();

    await this.em.emitAsync(new AfterNotifyEvent(notification));
  }
}